import React from "react";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import {
  Checkbox,
  IconButton,
  makeStyles,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";

// Custom styles for selected rows and status labels
const useStyles = makeStyles((theme) => ({
  row: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  selectedRow: {
    backgroundColor: "#e6e6e6 !important", 
  },
}));

const OrderPackagesTableRow = ({
  pkg,
  selectedPackages,
  onSelectPackage,
  onOpenFileViewer,
  onOpenPackageDetails,
  selectedStatus,
}) => {
  const classes = useStyles();
  const isSelected = selectedPackages.has(pkg?.id);

  const handleCheckboxChange = (e) => {
    e.stopPropagation(); // Stop event from bubbling up to the row
    onSelectPackage(pkg.id);
  };
  const handleRowClick = () => {
    if (selectedStatus !== "Ready") return; // Do nothing if status is not "Ready"
    onSelectPackage(pkg.id);
  };

  return (
    <TableRow
      className={`${classes.row} ${isSelected ? classes.selectedRow : ""}`}
      onClick={handleRowClick}
      selected={isSelected}
    >
      <TableCell className="px-4 py-2 border-b">
        <Checkbox
          disabled={selectedStatus !== "Ready"}
          color="primary"
          checked={isSelected}
          onChange={handleCheckboxChange}
          onClick={(e) => e.stopPropagation()} // Additional protection to ensure click doesn't propagate
        />
      </TableCell>
      <TableCell>
      <Typography
        className="px-2 py-1 rounded-full"
          variant="caption"
          style={{
            border: "1px solid #c4c4c4",
            backgroundColor: "#e5e5e5",
            color: "#585656",
          }}
        >
          {pkg.packageRepresentation}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography
        className="px-2 py-1 rounded-full"
          variant="caption"
          style={{
            border: "1px solid #30b46e",
            backgroundColor: "#a0e2be",
            color: "#04783a",
          }}
        >
          {pkg.order?.orderNumber}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="caption">
          {pkg.order?.shippingAddress?.recipientName}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="caption">{pkg.box.name}</Typography>
      </TableCell>
      <TableCell
        onClick={(e) => {
          if (pkg.fileId) {
            e.stopPropagation(); // Prevent row click when clicking icon
            onOpenFileViewer(pkg);
          }
        }}
      >
        {pkg.fileId ? (
          <IconButton size="small">
            <InsertDriveFileIcon />
          </IconButton>
        ) : (
          <Typography variant="caption">No Label</Typography>
        )}
      </TableCell>
      <TableCell>
        <div className="flex items-center">
          <span
            className={`inline-flex items-center justify-center px-2 text-xs font-medium rounded-full 
            ${
              pkg.status === "Ready" || pkg.status.includes("Ready")
                ? "bg-blue-200 text-blue-500"
                : pkg.status === "Printed"
                ? "bg-yellow-200 text-yellow-500"
                : pkg.status === "Packed"
                ? "bg-green-200 text-green-500"
                : pkg.status === "Scanned"
                ? "bg-purple-200 text-purple-500"
                : "bg-gray-200 text-gray-800"
            }
          `}
          >
            <Typography variant="caption">{pkg.status}</Typography>
          </span>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default OrderPackagesTableRow;
